import React from 'react';
import { Input, InputNumber } from 'antd';
import { TextComponent } from 'baseComponents/TextComponent';
import 'baseComponents/InputComponent/inputComponent.scss';

interface Props {
  placeholder?: string;
  allowClear?: boolean;
  maxLength?: number;
  disabled?: boolean;
  value: string;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
  onPressEnter?: () => void;
  id?: string;
  labelValue?: string;
  linkLabel?: string;
  passwordInput?: boolean;
  numericInput?: boolean;
  fullWidth?: boolean;
  textarea?: boolean;
}

export const InputComponent: React.FC<Props> = ({
  disabled = false,
  ...props
}) => {
  if (props.textarea) {
    return (
      <Input.TextArea
        rows={4}
        onChange={props.onChange}
        className='textarea-component'
        disabled={disabled}
        value={props.value}
        maxLength={props.maxLength}
      />
    );
  }
  return (
    <div className={`${props.fullWidth && 'full-width'}`}>
      <div className='labels-wrapper'>
        {props.labelValue && (
          <div className='input-wrapper'>
            <TextComponent
              weight='extra-light'
              text={props.labelValue}
              type='span'
            />
          </div>
        )}
        {props.linkLabel && (
          <div className='input-wrapper'>
            <TextComponent
              weight='extra-light'
              size='small'
              text={props.linkLabel}
              type='span'
              opacity
            />
          </div>
        )}
      </div>
      {props.passwordInput ? (
        <Input.Password
          className='input-component'
          placeholder={props.placeholder}
          allowClear={props.allowClear}
          maxLength={props.maxLength}
          disabled={disabled}
          value={props.value}
          onChange={props.onChange}
          onPressEnter={props.onPressEnter}
          id={props.id}
          bordered={false}
        />
      ) : props.numericInput ? (
        <InputNumber
          type='number'
          className='input-component'
          placeholder={props.placeholder}
          maxLength={props.maxLength}
          disabled={disabled}
          value={parseFloat(props.value as string)}
          onChange={(value) =>
            props.onChange({
              target: { value: String(value) },
            } as React.ChangeEvent<HTMLInputElement>)
          }
          onPressEnter={props.onPressEnter}
          id={props.id}
          bordered={false}
        />
      ) : (
        <Input
          className='input-component'
          placeholder={props.placeholder}
          allowClear={props.allowClear}
          maxLength={props.maxLength}
          disabled={disabled}
          value={props.value}
          onChange={props.onChange}
          onPressEnter={props.onPressEnter}
          id={props.id}
          bordered={false}
        />
      )}
    </div>
  );
};
